module.exports = __webpack_public_path__ + "img/login_dashboard_image.7695a27b.png";